/**
 * Copyright (c) 2021 TechDivision GmbH
 * All rights reserved
 */

import LocalStorageObjectHelper from "./LocalStorageObjectHelper"

/**
 * @module ProductComparisonCart
 * handles the events for the product comparison cart
 */
class ProductComparisonCart {

    constructor() {
        this.productIdentifier = ''
        this.productName = ''
        this.productCompareAddButton = document.querySelector('.js-product_comparison--cta-btn')
        this.comparisonHeaderLink = document.querySelectorAll('.js-header-icon-bar--item-comparison')
        this.comparisonHeaderIconCounter = $('.js-header-icon-bar--item-comparison-cart-counter')
        this.maxItemsInComparison = 3
        this.ProductComparisonDataHelper = new LocalStorageObjectHelper('comparisonProducts')
        this.init()
    }

    init() {
        // Always Update the cart counter in the header
        this.updateHeaderComparisonCounter()

        // Is product at comparison
        this.updateComparisonButton()

        let that = this;

        // Update the header link
        this.comparisonHeaderLink.forEach((element) => {
            that.updateHeaderLink($(element))
        })

        // Check if the product compare button is available
        if (this.productCompareAddButton != null) {
            this.bindEvents()
        }
    }

    /**
     * Bind all needed events
     *
     * @method bindEvents
     */
    bindEvents() {
        this.productCompareAddButton.addEventListener('click', () => {
            this.updateItem()
        });
    }

    /**
     * Add or remove item form temp cart object
     * @return {undefined}
     */
    updateItem() {
        if (this.itemIsInComparison()) {
            this.removeItem()
        } else {
            this.addItem()
        }
        let that = this;

        this.comparisonHeaderLink.forEach(function () {
            that.updateHeaderLink($(this))
        })
    }

    /**
     * Return if the item is already in the cart
     * @returns {boolean}
     */
    itemIsInComparison() {
        let itemIsInComparison = false;
        // Check if anything in cart
        if (this.getTotalAmountOfItemsInCart() > 0) {
            // Check if current product is on cart
            itemIsInComparison = this.ProductComparisonDataHelper.get(this.productIdentifier) !== undefined
        }
        return itemIsInComparison
    }

    /**
     * Remove item to temp cart object
     * @return {undefined}
     */
    removeItem() {
        $(this.productCompareAddButton).removeClass('btn-with-check')
        // Remove the item from current item array
        this.ProductComparisonDataHelper.delete(this.productIdentifier)
        // Update local storage
        // Update counter
        this.updateHeaderComparisonCounter();
        // Update header link
        this.comparisonHeaderLink.forEach((element) => {
            this.updateHeaderLink($(element))
        })
    }

    /**
     * add item to temp cart object
     * @return {undefined}
     */
    addItem() {
        let productFigure = document.querySelector('.js-product-images--figure')

        let dataForComparison = {
            name: this.productName,
            code: productFigure.dataset.colorOrderCode,
            productIdentifier: this.productIdentifier,
        }

        // If the cart is already full, just remove the first entry
        if (this.ProductComparisonDataHelper.data.length >= this.maxItemsInComparison) {
            this.ProductComparisonDataHelper.replace(
                this.ProductComparisonDataHelper.data.shift().productIdentifier,
                dataForComparison
            )
        } else {
            this.ProductComparisonDataHelper.add(dataForComparison)
        }

        // Set class for active
        $(this.productCompareAddButton).addClass('btn-with-check')
        // Update counter
        this.updateHeaderComparisonCounter();
        // Update the header link
        this.comparisonHeaderLink.forEach((element) => {
            this.updateHeaderLink($(element))
        })
    }

    /**
     * Update the cart counter in the header
     */
    updateHeaderComparisonCounter() {
        let val = this.getTotalAmountOfItemsInCart()

        if (val === 0) {
            this.comparisonHeaderIconCounter.text('')
            this.comparisonHeaderIconCounter.addClass('hidden')
        } else {
            this.comparisonHeaderIconCounter.text(val)
            this.comparisonHeaderIconCounter.removeClass('hidden')
        }
    }

    /**
     * Update the cart counter in the header
     */
    updateComparisonButton() {
        let button = document.querySelector('.js-product_comparison--cta-btn')
        if (button) {
            this.productIdentifier = button.dataset.productIdentifier
            this.productName = button.dataset.productTitle
            if (this.productIdentifier && this.ProductComparisonDataHelper.get(this.productIdentifier)) {
                $('.js-product_comparison--cta-btn').addClass('btn-with-check')
            }
        }
    }

    /**
     * Return the total amount of item in the comparison cart
     *
     * @returns {number}
     */
    getTotalAmountOfItemsInCart() {
        if (this.ProductComparisonDataHelper.data.length < 1) {
            return 0
        }
        return this.ProductComparisonDataHelper.data.length
    }

    /**
     * Update header link for product comparison
     *
     * @method updateHeaderLink
     */
    updateHeaderLink(comparisonHeaderLink) {
        let targetUrl = comparisonHeaderLink.attr('href')
        if (targetUrl === undefined) {
            return
        }
        if (!targetUrl.startsWith('/')) {
            targetUrl = '/' + targetUrl
        }

        let clearLink = targetUrl.split('?')[0]
        if (!this.ProductComparisonDataHelper.data.length) {
            comparisonHeaderLink.attr('href', clearLink)
            return
        }

        let counter = 1
        let glue = '?'
        for (let product of this.ProductComparisonDataHelper.data) {
            glue = counter > 1 ? '&' : glue
            clearLink = clearLink + glue + 'prod' + counter + '=' + product.productIdentifier
            counter++
        }
        comparisonHeaderLink.attr('href', clearLink)
    }

}

function initProductComparisonCart() {
    new ProductComparisonCart()
}

// If the script is initialized after the document is already loaded, initialize modules instantly
if (document.readyState !== 'loading') {
    initProductComparisonCart()
} else {
    // Else add an event listener for when the document is fully loaded
    document.addEventListener('DOMContentLoaded', initProductComparisonCart)
}
